export const NATALCHART_YEAR_LIMIT = 105

export const getCurrentAdYear = (date = new Date()) => date.getFullYear()

export const getCurrentRocYear = (date = new Date()) => getCurrentAdYear(date) - 1911

export const getNatalchartYearRange = (calendar, date = new Date()) => {
  const currentAdYear = getCurrentAdYear(date)
  const currentRocYear = getCurrentRocYear(date)
  const minRocYear = currentRocYear - NATALCHART_YEAR_LIMIT

  if (calendar === '西元') {
    return {
      min: minRocYear + 1911,
      max: currentAdYear
    }
  }

  return {
    min: minRocYear,
    max: currentRocYear
  }
}

export const getNatalchartYearOptions = (calendar, date = new Date()) => {
  const { min, max } = getNatalchartYearRange(calendar, date)
  return Array.from({ length: max - min + 1 }, (_, index) => min + index)
}
